<script>
import {addCompanyTokens} from "@/api/accounts.js";
import swal from "sweetalert";

export default {
  name: "add-api",
  components: {
    
  },
  props: {
  },
  data() {
    return {
      form: '',
      apiName: '',
      loading:false
    };
  },
  async mounted() {
    
  },
  watch:{
  },
  computed: {
  },
  methods: {
    showModal(){
      this.$refs["modalAdd"].show();
    },
    hideModal(data = ''){
      this.loading = false
      this.apiName = ''
      this.$refs["modalAdd"].hide();
    },
    async onSubmit() {
      this.loading = true
      let nameFIeldChk = this.apiName .replace(/^\s+|\s+$/gm,'');

      if(nameFIeldChk == ''){
        swal("Error!", "All spaces only is not accepted");
        this.loading = false
        return false
      }
      const payload = JSON.parse(
        JSON.stringify({ name: this.apiName })
      );
      let resp = await addCompanyTokens(payload)
      swal("Great!", "Successfully created");
      this.hideModal()
    },
    
  }
};
</script>

<template>
  <b-modal
    id="modal-add-api"
    ref="modalAdd"
    title="Create API key"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
  >
    <b-form
        v-on:submit.prevent="onSubmit"
        method="POST"
        accept-charset="UTF-8"
        enctype="multipart/form-data"
        id="form-modal-add-api-key" 
    >
      <b-form-group label="API Name">
        <b-form-input maxlength="50" v-model.trim="apiName" required></b-form-input>
      </b-form-group>
      <b-button 
        type="submit" 
        class="float-right" 
        variant="primary"
        style="width: 70px;">
        <span  v-if="!loading">
          Create
        </span>
        <span width="100px">
          <v-progress-circular v-if="loading" indeterminate size="20"></v-progress-circular>
        </span>
      </b-button>
    </b-form> 
  </b-modal>
</template>

<style scoped>
</style>
